import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { get } from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { Text } from '@bingads-webui-react/fabric-control';

export const NewCustomerAcquisition = ({ data, currencyCode }) => {
  const i18n = useContext(I18nContext);
  const { newCustomerAcquisitionOptOut, newCustomerAcquisition } = data || {};
  const { campaignSettings, accountSettings } = newCustomerAcquisition || {};

  const summary = useMemo(() => {
    let summaryText = newCustomerAcquisitionOptOut ? i18n.getString(_TL_('Off')) : i18n.getString(_TL_('On'));

    if (!newCustomerAcquisitionOptOut) {
      const bidOnlyMode = get(campaignSettings, 'bidOnlyMode', false);
      const campaignAdditionalValue = get(campaignSettings, 'additionalConversionValue', 0) || 0;
      const accountAdditionalValue = get(accountSettings, 'additionalConversionValue', 0) || 0;

      if (!bidOnlyMode) {
        if (campaignAdditionalValue !== 0) {
          summaryText += i18n.getString(_TL_('; Bid higher for new customers; Additional conversion value'));
          summaryText += ` ${i18n.formatCurrency(campaignAdditionalValue, currencyCode)}`;
        } else {
          summaryText += i18n.getString(_TL_('; Bid higher for new customers; Additional conversion value (account level setting)'));
          summaryText += ` ${i18n.formatCurrency(accountAdditionalValue, currencyCode)}`;
        }
      } else {
        summaryText += i18n.getString(_TL_('; Bid only for new customers'));
      }
    }

    return summaryText;
  }, [accountSettings, campaignSettings, currencyCode, i18n, newCustomerAcquisitionOptOut]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('New Customer Acquisition') }}>
      <Text>{summary}</Text>
    </PropertyRow>
  );
};

NewCustomerAcquisition.propTypes = {
  data: PropTypes.shape({
    newCustomerAcquisitionOptOut: PropTypes.bool,
    newCustomerAcquisition: PropTypes.shape({
      campaignSettings: PropTypes.shape({}),
      accountSettings: PropTypes.shape({}),
    }),
  }),
  currencyCode: PropTypes.string,
};

NewCustomerAcquisition.defaultProps = {
  data: {
    newCustomerAcquisitionOptOut: true,
    newCustomerAcquisition: {
      campaignSettings: {},
      accountSettings: {},
    },
  },
  currencyCode: '',
};
